import PreservedRateModalButton from "legacy/preserved_rates_table/PreservedRateModalButton"
import PropTypes from "prop-types"
import React from "react"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

class MbmPricingEstimate extends React.Component {
  constructor(props) {
    super(props)

    this.VARIANTS = {
      default: {
        pricingYMargin: "my-8",
      },
      pendingBoaterReservationPage: {
        pricingYMargin: "mb-8",
      },
    }
  }

  pricingSection() {
    const {
      loadingPrice,
      priceErrorMessage,
      chargeBreakdown,
      creditBreakdown,
      totalPrice,
      tax,
      isMonthlyBillingSchedule,
    } = this.props

    const currency = window.currentMarina?.presentmentCurrency || "USD"

    if (loadingPrice) {
      return this.loadingSpinner()
    }

    if (chargeBreakdown) {
      // chargeBreakdown and creditBreakdown are arrays of {label:, amount:}
      return (
        <div className="grid gap-y-2">
          {chargeBreakdown.map((charge) => (
            <div key={charge.label} className="grid grid-cols-2">
              <div>{charge.label}</div>
              <div className="text-right">
                {formatCurrencyFromMinorUnits({
                  amount: charge.amount,
                  currency,
                })}
              </div>
            </div>
          ))}
          <hr className="my-2 w-full border-t border-solid border-gray-300" />
          {creditBreakdown.map((discount) => (
            <div key={discount.label} className="grid grid-cols-2">
              <div className="text-xs">{discount.label}</div>
              <div className="text-right">
                {formatCurrencyFromMinorUnits({
                  amount: -discount.amount,
                  currency,
                })}
              </div>
            </div>
          ))}
          <div className="grid grid-cols-2">
            <div className="text-xs">Tax</div>
            <div className="text-right">
              {formatCurrencyFromMinorUnits({ amount: tax, currency })}
            </div>
          </div>
          <div className="grid grid-cols-2">
            <div className="text-sm font-bold">
              {isMonthlyBillingSchedule ? "Monthly Total" : "Total"}
            </div>
            <div className="text-right text-sm font-bold">
              {formatCurrencyFromMinorUnits({ amount: totalPrice, currency })}
            </div>
          </div>

          {priceErrorMessage && (
            <div className="grid grid-cols-1">
              <div className="text-danger">{priceErrorMessage}</div>
            </div>
          )}
          <PreservedRateModalButton
            preservedRates={this.props.preservedRates}
            fullWidth={true}
          />
        </div>
      )
    }
  }

  paymentsDueSection() {
    const { loadingPrice, paymentsDue, isMonthlyBillingSchedule } = this.props

    const currency = window.currentMarina?.presentmentCurrency || "USD"

    if (loadingPrice) {
      return this.loadingSpinner()
    }

    return (
      <div className="grid gap-y-2">
        {paymentsDue.map((payment) => (
          <div key={payment.label} className="grid grid-cols-2">
            <div>{payment.label}</div>
            <div className="text-right">
              {formatCurrencyFromMinorUnits({
                amount: payment.amount,
                currency,
              })}
            </div>
          </div>
        ))}
        {isMonthlyBillingSchedule && (
          <div className="grid grid-cols-2">
            <div className="text-sm font-bold">Total</div>
            <div className="text-right text-sm font-bold">
              {formatCurrencyFromMinorUnits({
                amount: paymentsDue.reduce(
                  (acc, payment) => acc + payment.amount,
                  0
                ),
                currency,
              })}
            </div>
          </div>
        )}
      </div>
    )
  }

  loadingSpinner() {
    return (
      <div className="h4 text-danger text-center">
        <i className="icon icon-spinner icon-spin text-muted" />
      </div>
    )
  }

  render() {
    const { variant = "default" } = this.props
    const variantClasses = this.VARIANTS[variant]

    return (
      <div>
        <div
          className={`rounded p-4 ${variantClasses.pricingYMargin} bg-gray-100`}
        >
          <h4 className="mt-0 font-semibold">Pricing</h4>
          {this.pricingSection()}
        </div>
        <div className="my-8 rounded bg-gray-100 p-4">
          <h4 className="mt-0 font-semibold">Payments Due</h4>
          {this.paymentsDueSection()}
        </div>
      </div>
    )
  }
}

MbmPricingEstimate.propTypes = {
  loadingPrice: PropTypes.bool,
  priceErrorMessage: PropTypes.string,
  chargeBreakdown: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
    })
  ),
  creditBreakdown: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
    })
  ),
  totalPrice: PropTypes.number,
  tax: PropTypes.number,
  isMonthlyBillingSchedule: PropTypes.bool,
  preservedRates: PropTypes.array,
  paymentsDue: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
    })
  ),
  variant: PropTypes.oneOf(["default", "pendingBoaterReservationPage"]),
}

export default MbmPricingEstimate
